import { useEffect } from "react"
import { useNavigate } from "@tanstack/react-router"
import { JugglingScreen } from "@motleyhand/design"
import { toast } from "sonner"
import { parseUnknownError } from "@/base"
import { useApplyVerifyEmailMutation } from "@/auth"

const DEFAULT_ERROR = "Email verification failed. Please try again."

type Props = {
  params: Record<string, string>
}

// Route has to match app_verify_email in the backend, see backend/Security/EmailVerifier.php:48
export default function ApplyVerifyEmail({ params }: Props) {
  const [applyVerifyEmail] = useApplyVerifyEmailMutation()
  const navigate = useNavigate()

  useEffect(() => {
    void (async () => {
      try {
        await applyVerifyEmail(params).unwrap()
        toast.success("Your email address has been verified.")
        await navigate({ to: "/", replace: true })
      } catch (e) {
        const violations = parseUnknownError(e)

        toast.error(
          violations ? (violations[0]?.title ?? DEFAULT_ERROR) : DEFAULT_ERROR,
        )
        await navigate({ to: "/auth/verify/request", replace: true })
      }
    })()
  }, [params, applyVerifyEmail, navigate])

  return <JugglingScreen />
}
